import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMetaDataGridActionState, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateChallengeModalComponent } from './create-challenge-modal.component';

@DwAction({ keyName: 'create-challenge', display: 'Create Challenge', actionType: DwActionType.menuAction,
    isGlobal: true, allowOnce: true, configData: { requireValidation: false, redirectAfter: false, actionMessage: '' } })
@Injectable()
export class CreateChallengeActionService implements DwActionHandler {
    constructor(private modal: DwModalService) {}
    handleAction(state: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        const config = new DwModalConfig<any>();
        config.title = 'Create Challenge'; config.component = CreateChallengeModalComponent;
        config.buttons = DwModalButtonStandardConfigs.instance.okAndClose; config.modalSize = DwModalSize.responsive;
        return this.modal.showModal(config).pipe(map(modalResult => {
            const result = new DwActionResult(); result.cancelled = modalResult.cancelled;
            result.success = !modalResult.cancelled && !!modalResult.data;
            if (result.success) {
                state.metaDataGridApi.refreshDataSource(true);
                result.message = modalResult.data.isCurrent ? 'Challenge created and made current.' : 'Challenge created as a draft.';
            }
            return result;
        }));
    }
}
